import { jsx as r } from "react/jsx-runtime";
import { p as e } from "../../../floating-ui.react-SmaXvp4L.js";
const m = ({
  children: t,
  parentPopover: o
}) => o ? /* @__PURE__ */ r(e, { elementsRef: o.list, children: t }) : t;
export {
  m as NestedPopoverActivator
};
